import { Box, Typography } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { CustomTooltip } from '../CustomTooltip/CustomTooltip';

interface HeaderWithTooltipProps {
  label: string;
  tooltip: string;
}

export const HeaderWithTooltip: React.FC<HeaderWithTooltipProps> = ({ label, tooltip }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, userSelect: 'none' }}>
    <CustomTooltip title={tooltip} placement="top">
      <HelpOutlineIcon sx={{ cursor: 'help', color: 'text.secondary', fontSize: 14 }} />
    </CustomTooltip>
    <Typography
      component="span"
      fontWeight={600}
      fontSize="0.875rem"
      lineHeight={1.43}
    >
      {label}
    </Typography>
  </Box>
);
